import React, {Component} from 'react';
import css from './banner.scss';
import {withRouter} from 'react-router';
import img from '../../assets/img/utilisateurs.svg';
import Filter from '../filter/filter';

class Banner extends Component {
	render() {
		return (
			<div className={css.banner}>
				<img src={img} className={css.subtitle} alt="Les Utilisateurs"/>
				<Filter></Filter>
				{/* <Search /> */}
			</div>
		);
	}
}

export default withRouter(Banner);



// WEBPACK FOOTER //
// ./src/components/banner/banner.js